import type { LockerverseProduct } from "./types.ts";

const minimumCustomAmountCents = 100;

export function getLockerverseMinimumCustomAmountCents(
  product: Pick<LockerverseProduct, "minimumAmountCents">
) {
  return Math.max(minimumCustomAmountCents, product.minimumAmountCents ?? 0);
}
